import * as React from 'react';
import {DataGrid} from '@material-ui/data-grid';


export default function FilterTable({rows,isLoading}) {
    if (!rows) rows = [];
    // console.log(isLoading())
    const columns = [
        {field: 'id', headerName: 'Id', width: 250},
        {field: 'Categorie', headerName: 'Categorie', width: 200},
        {field: 'InternalId', headerName: 'InternalId', width: 200},
        {field: 'Barcode', headerName: 'Barcode', width: 200},
        {field: 'Name', headerName: 'Name', width: 400},
        {field: 'Price', headerName: 'Price', width: 100},
        {field: 'IsProductValidated', headerName: 'Status', width: 100},
    ];

    return (
        <div style={{height: 400, width: '100%'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={25}
                loading={isLoading()}
                checkboxSelection
            />
        </div>
    );
}
